// extracted by mini-css-extract-plugin
export default {"products":"ProductsList_products__nrchk","productsList":"ProductsList_productsList__qOQf6","error":"ProductsList_error__Lp70B"};